import Container from 'components/Container/Container';
import Loader from 'components/Loader/Loader';
import Redirecting from 'components/Redirecting/Redirecting';
import { useSessionContext } from 'context/SessionProvider/SessionProvider';
import { History } from 'history';
import {
  DealLegacy,
  DealLegacyStatus,
  PermissionName,
  useAllActiveDealsLegacyQuery,
} from 'interfaces/generated.types';
import React from 'react';
import { userHasAtLeastOnePermission } from 'utils/permissions';

import DealsTable from '../../components/DealsTable/DealsTable';
import useStyles from './ActiveDealsPage.styles';

interface IActiveDealsPageProps {
  history: History;
  userPermissions: PermissionName[];
}

const editPermissions = [PermissionName.Primary, PermissionName.Programmatic];

const ActiveDealsPage = ({
  history,
  userPermissions,
}: IActiveDealsPageProps) => {
  const classes = useStyles();

  const {
    state: {
      user: { activeTerritory },
    },
  } = useSessionContext();

  const { loading, data, error } = useAllActiveDealsLegacyQuery({
    errorPolicy: 'all',
    variables: {
      territories: [activeTerritory!],
      filter: {
        status_in: [DealLegacyStatus.Active],
      },
    },
  });

  if (!loading && (error || !(data && data.allDealsLegacy)))
    return <Redirecting history={history} />;

  const hasEditPermissions = userHasAtLeastOnePermission(
    userPermissions,
    editPermissions
  );

  return (
    <main>
      <Container>
        <h1 className="sr-only">Active Deals</h1>
        <div className={classes.table}>
          {loading ? (
            <Loader />
          ) : (
            <DealsTable
              history={history}
              isEditable={hasEditPermissions}
              deals={data?.allDealsLegacy as DealLegacy[]}
            />
          )}
        </div>
      </Container>
    </main>
  );
};

export default ActiveDealsPage;
